import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsentBanner.scss';

const COOKIE_CONSENT_KEY = 'trnd_cookie_consent';

export default function CookieConsentBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay to prevent flash on page load
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      essential: true,
      analytics: true,
      functionality: true,
      marketing: true,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  const handleAcceptEssential = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      essential: true,
      analytics: false,
      functionality: false,
      marketing: false,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <h4>We value your privacy</h4>
          <p>
            We use cookies to enhance your browsing experience, serve personalized content, 
            and analyze our traffic. By clicking "Accept All", you consent to our use of cookies. 
            Read our <Link to="/cookie-policy">Cookie Policy</Link> to learn more.
          </p>
        </div>
        <div className="cookie-consent-buttons">
          <button 
            className="btn-essential"
            onClick={handleAcceptEssential}
          >
            Essential Only
          </button>
          <button 
            className="btn-accept"
            onClick={handleAcceptAll}
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}

// Utility function to check cookie consent
export function getCookieConsent() {
  const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
  if (consent) {
    return JSON.parse(consent);
  }
  return null;
}

// Utility function to check if specific cookie type is allowed
export function isCookieAllowed(type) {
  const consent = getCookieConsent();
  if (!consent) return false;
  return consent[type] === true;
}
